<template>
  <b-modal id="customFieldAddModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.customField.create.header') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="created" class="alert alert-success" role="status">{{ created.fieldName }} {{$t('notifications.created')}}.</div>
        <div v-if="isLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
        <div v-if="error" class="alert alert-danger" role="alert">
          <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
        </div>
      </b-col>
    </b-row>
    <b-row v-if="item && fieldTypes">
      <b-col>
        <CustomFieldForm :item="item" :fieldTypes="fieldTypes"></CustomFieldForm>
      </b-col>
    </b-row>
    <b-row v-for="(customFieldValue, index) in item.fieldValues" v-bind:key="'customFieldValue-' + index">
      <b-col>
        <CustomFieldValue :item="customFieldValue" :items="item.fieldValues" :index="index"></CustomFieldValue>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="float-right">
          <button v-if="!created" type="submit" class="btn btn-success" @click="storeObject()">{{$t('buttons.save')}}</button>
          <b-button class="btn btn-secondary" @click="closeModal()">{{ closeText }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import CustomFieldForm from '../CustomFieldForm'
import CustomFieldValue from '../CustomFieldValue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('excmcustomfield/create')
export default {
  name: 'CustomFieldAddModal',
  components: {
    CustomFieldForm,
    CustomFieldValue
  },
  props: {
    fieldTypes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      modalShow: 0,
      routeName: '',
      closeText: this.$t('buttons.close'),
      fieldParent: {},
      item: {
        fieldName: '',
        fieldType: 'input',
        fieldDefaultValue: '',
        fieldLabel: '',
        fieldDescription: '',
        fieldRequired: 0,
        fieldReadonly: 0,
        onlyNumbersAllowed: 0,
        allowedDaysBack: null,
        allowedDaysAhead: null,
        minValue: null,
        maxValue: null,
        fieldValues: [],
        disabledRoles: [],
        idUserDataClientTypes: [],
        showInTable: 0
      }
    }
  },

  created () {
    this.routeName = this.$route.name
  },
  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),
    show () {
      return this.$store.state.modals.customField.create.show
    },
    parent () {
      return this.$store.state.modals.customField.create.parent
    },
    customFieldValueObject () {
      return this.$store.state.modals.customFieldValue.create.customFieldValueObject
    }
  },
  watch: {
    show: function (val) {
      this.openModal()
    },
    parent: function (val) {
      this.openModal()
    },
    customFieldValueObject: function (val) {
      this.appendNewValue(val)
    },
    created: function (created) {
      if (!created) {
        return
      }
      if (this.routeName === 'EXCMCaseTypeShow' || this.routeName === 'EXCMTaskTypeShow') {
        this.$store.state.modals.customField.create.customFieldObject = created
      }
      this.closeModal()
    }
  },
  methods: {
    ...mapActions([
      'create'
    ]),
    appendNewValue (value) {
      if (Object.entries(value).length > 0 && this.modalShow === 1) {
        this.item.fieldValues.push(value)
        this.$store.state.modals.customFieldValue.create.customFieldValueObject = {}
      }
    },
    openModal () {
      if (this.show === 1 && Object.entries(this.parent).length > 0) {
        this.fieldParent = this.$store.state.modals.customField.create.parent
        this.$store.state.modals.customField.create.show = 0
        this.$store.state.modals.customField.create.parent = {}
        this.modalShow = 1
        this.$bvModal.show('customFieldAddModal')
        this.createFieldTypeWatcher()
      }
    },
    closeModal () {
      this.$bvModal.hide('customFieldAddModal')
      this.unwatchFieldType()
    },
    resetData () {
      this.item = {
        fieldName: '',
        fieldType: 'input',
        fieldDefaultValue: '',
        fieldLabel: '',
        fieldDescription: '',
        fieldRequired: 0,
        fieldReadonly: 0,
        onlyNumbersAllowed: 0,
        allowedDaysBack: null,
        allowedDaysAhead: null,
        minValue: null,
        maxValue: null,
        fieldValues: [],
        disabledRoles: [],
        idUserDataClientTypes: []
      }
      this.modalShow = 0
      if (
        this.routeName === 'EXCMCaseTypeShow' ||
        this.routeName === 'EXCMTaskTypeShow' ||
        this.routeName === 'EXCMCaseTypeUpdate' ||
        this.routeName === 'EXCMTaskTypeUpdate') {
        this.$store.state.excmcustomfield.create.created = null
      }
    },
    storeObject () {
      if (this.routeName === 'EXCMCaseTypeCreate' || this.routeName === 'EXCMTaskTypeCreate') {
        this.$store.state.modals.customField.create.customFieldObject = this.item
        this.closeModal()
      } else if (this.routeName === 'EXCMCaseTypeShow' || this.routeName === 'EXCMTaskTypeShow' || this.routeName === 'EXCMCaseTypeUpdate' || this.routeName === 'EXCMTaskTypeUpdate') {
        let item = Object.assign({}, this.item)
        if (this.routeName === 'EXCMCaseTypeShow' || this.routeName === 'EXCMCaseTypeUpdate') {
          item.caseType = this.fieldParent['@id']
        } else if (this.routeName === 'EXCMCaseTypeShow' || this.routeName === 'EXCMTaskTypeUpdate') {
          item.taskType = this.fieldParent['@id']
        }
        if (item.allowedDaysAhead) {
          item.allowedDaysAhead = parseInt(item.allowedDaysAhead)
        }
        if (item.allowedDaysBack) {
          item.allowedDaysBack = parseInt(item.allowedDaysBack)
        }
        if (item.minValue) {
          item.minValue = parseInt(item.minValue)
        }
        if (item.maxValue) {
          item.maxValue = parseInt(item.maxValue)
        }
        this.create(item)
      }
    },
    createFieldTypeWatcher () {
      this.unwatchFieldType = this.$watch(
        function () {
          return this.item.fieldType
        },
        function (newValue) {
          this.item.fieldDefaultValue = ''
        }
      )
    }
  }
}
</script>
